import _ from 'lodash';
import request from 'superagent';
import url from '../../utils/url';
import * as reportsTabContants from '../../constants/reportsTabContants';
import * as errorConstants from '../../constants/errorConstants';


function removeFalsyValues(obj) {
  return _.pickBy(obj, _.identity);
}

function requestReports() {
  return {
    type: reportsTabContants.REQUEST_REPORTS,
  };
}

function requestAutomateMailing() {
  return {
    type: reportsTabContants.REQUEST_AUTOMATE_MAILING_REPORTS,
  };
}

function receiveReports(resBody) {
  return {
    type: reportsTabContants.RECEIVE_REPORTS,
    resBody,
  };
}

function receiveAutomateMailing(resBody) {
  return {
    type: reportsTabContants.RECEIVE_AUTOMATE_MAILING_REPORTS,
    resBody,
  };
}

function receiveError(error, type) {
  return { type, error };
}

function onSuccessReceiveReports(dispatch) {
  return function (res) {
    return dispatch(receiveReports(res.body));
  };
}

function onSuccessAutomateMailing(dispatch) {
  return function (res) {
    return dispatch(receiveAutomateMailing(res.body));
  };
}

function onFailure(dispatch) {
  return function (error) {
    return dispatch(receiveError(error, errorConstants.SERVER_ERROR));
  };
}

export const reports = params => function (dispatch) {
  dispatch(requestReports());
  const filters = removeFalsyValues(params);

  return request
    .post(url('/localsearch/search-json'))
    .send(filters)
    .set('Content-Type', 'application/json')
    .then(onSuccessReceiveReports(dispatch), onFailure(dispatch));
};

export const automateMailing = params => function (dispatch) {
  dispatch(requestAutomateMailing());

  const filters = removeFalsyValues(params);

  return request
    .post(url('/localsearch/add-alert'))
    .send(filters)
    .set('Content-Type', 'application/json')
    .then(onSuccessAutomateMailing(dispatch), onFailure(dispatch));
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/reportsTabAction.js
 **/